exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".avatar-editor .avatar-editor-remove{display:none}.avatar-editor:hover .avatar-editor-remove{display:inline-flex}", ""]);

// exports
